import SidebarQuickLinks from './SidebarQuickLinks';

interface AdFilterContainerProps {
  children?: React.ReactNode;
}

export default function AdFilterContainer({ children }: AdFilterContainerProps) {
  return (
    <aside className="sb-listing-sidebar" aria-label="Filtreler">
      <SidebarQuickLinks />
      {children}
    </aside>
  );
}
